import "./BisButton.css";
import {Button} from '@radix-ui/themes';
import PropTypes from "prop-types";
import clsx from "clsx";

const BisButton = ({text, onClick, className}) => {
    return (
        <Button onClick={onClick} className={clsx("button", className)}>
            <span className={clsx("button-text", text)}>{text}</span>
        </Button>
    );
};


BisButton.propTypes = {
    text: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    className: PropTypes.string,
};

export default BisButton;
